const CREDIT_CARD_NUMBER_REENTRY_REQUIRED_TYPE = 'CardNumberRentryRequired';
const UNVERIFIED_CARD_TYPE = 'UNVERIFIED';
const CREDIT_CARD_MAX_LENGTH = 16;
const AMEX_CREDIT_CARD_MAX_LENGTH = 15;
const PHONE_NUMBER_MAX_LENGTH = 15;
const DEFAULT_CARD_ICON_NAME = 'icon-neutral.svg';
const JCP_CARD_ICON_NAME = 'jcp-black.png';
const JCP_CARD_DIM_ICON_NAME = 'jcp-new-dim.svg';
const DUAL_CARD_ICON_NAME = 'dual-black.png';
const DUAL_CARD_DIM_ICON_NAME = 'dual-new-dim.svg';
const VISA_CARD_ICON_NAME = 'visa-new.svg';
const VISA_CARD_DIM_ICON_NAME = 'visa-new-dim.svg';
const MASTER_CARD_ICON_NAME = 'master-new.svg';
const MASTER_CARD_DIM_ICON_NAME = 'master-new-dim.svg';
const DISCOVER_CARD_ICON_NAME = 'discover-new.svg';
const DISCOVER_CARD_DIM_ICON_NAME = 'discover-new-dim.svg';
const AMEX_CARD_ICON_NAME = 'amex-new.svg';
const AMEX_CARD_DIM_ICON_NAME = 'amex-new-dim.svg';
const PLCC_ILLUCSTRATION = 'plcc-illustration.svg';
const MARKETPLACE_UNSUPPORTED_CARD_ERROR_MESSAGE =
    'Please use a different payment method for this purchase. Orders with third-party seller items can’t be paid with a JCPenney Credit Card or American Express at this time.';
const MARKETPLACE_RESTRICTED_CARD_TYPES = ['jcp', 'dualcard', 'amex'];
const cardImageMap = {
    visa: {
        key: 'visaCardImage',
        imageName: VISA_CARD_ICON_NAME,
    },
    mastercard: {
        key: 'masterCardImage',
        imageName: MASTER_CARD_ICON_NAME,
    },
    discover: {
        key: 'discoverCardImage',
        imageName: DISCOVER_CARD_ICON_NAME,
    },
    amex: {
        key: 'amexCardImage',
        imageName: AMEX_CARD_ICON_NAME,
    },
    jcp: {
        key: 'jcpCardImage',
        imageName: JCP_CARD_ICON_NAME,
    },
    dualcard: {
        key: 'dualCardImage',
        imageName: DUAL_CARD_ICON_NAME,
    },
    'jcpenney mastercard': {
        key: 'dualCardImage',
        imageName: DUAL_CARD_ICON_NAME,
    },
};
const BNPL_GC_WARNING_MSG = {
    type: 'error',
    message:
        'Synchrony Pay Later and gift cards cannot be used together on the same order. Please select a different payment method to use your gift card.',
};
export default {
    CREDIT_CARD_NUMBER_REENTRY_REQUIRED_TYPE,
    UNVERIFIED_CARD_TYPE,
    CREDIT_CARD_MAX_LENGTH,
    AMEX_CREDIT_CARD_MAX_LENGTH,
    PHONE_NUMBER_MAX_LENGTH,
    DEFAULT_CARD_ICON_NAME,
    JCP_CARD_ICON_NAME,
    JCP_CARD_DIM_ICON_NAME,
    DUAL_CARD_ICON_NAME,
    DUAL_CARD_DIM_ICON_NAME,
    VISA_CARD_ICON_NAME,
    VISA_CARD_DIM_ICON_NAME,
    MASTER_CARD_ICON_NAME,
    MASTER_CARD_DIM_ICON_NAME,
    DISCOVER_CARD_ICON_NAME,
    DISCOVER_CARD_DIM_ICON_NAME,
    AMEX_CARD_ICON_NAME,
    AMEX_CARD_DIM_ICON_NAME,
    PLCC_ILLUCSTRATION,
    MARKETPLACE_UNSUPPORTED_CARD_ERROR_MESSAGE,
    MARKETPLACE_RESTRICTED_CARD_TYPES,
    cardImageMap,
    BNPL_GC_WARNING_MSG,
};
